import { useState } from 'react';
import { jobAPI } from '../../../services/api';

// Extracted verbatim from JobManagement.js (Task 4).
//
// `diagnosticsLoading` was already its own flag in the original code
// (separate from the shared `isLoading`), so this hook keeps it separate
// too and does not take `setIsLoading` — matching the interface in
// task-4-brief.md exactly.
export const useDiagnostics = () => {
  const [allDiagnostics, setAllDiagnostics] = useState([]);
  const [diagnosticsPage, setDiagnosticsPage] = useState(1);
  const [diagnosticsTotalPages, setDiagnosticsTotalPages] = useState(1);
  const [diagnosticsLoading, setDiagnosticsLoading] = useState(false);
  const [selectedDiagnostic, setSelectedDiagnostic] = useState(null);

  const loadAllDiagnostics = async () => {
    setDiagnosticsLoading(true);
    try {
      const data = await jobAPI.getAllUserDiagnostics(diagnosticsPage, 20);
      setAllDiagnostics(data.diagnostics || []);
      setDiagnosticsTotalPages(data.total_pages || 1);
    } catch (error) {
      console.error('Error loading diagnostics:', error);
    } finally {
      setDiagnosticsLoading(false);
    }
  };

  return {
    allDiagnostics,
    diagnosticsPage,
    setDiagnosticsPage,
    diagnosticsTotalPages,
    diagnosticsLoading,
    selectedDiagnostic,
    setSelectedDiagnostic,
    loadAllDiagnostics
  };
};
